// KKMovie Types

export enum KKMovieStatusEnum {
  COMPLETE = 'complete',
  ONGOING = 'ongoing',
  UPCOMING = 'upcoming',
}

export enum KKMovieTypeEnum {
  SERIES = 'series',
  SINGLE = 'single',
  ANIME = 'anime',
  CINEMA = 'cinema',
}

export interface KKMovie {
  _id: string;
  name: string;
  url: string;
  description: string;
  year?: number;
  status: KKMovieStatusEnum;
  type: KKMovieTypeEnum;
  current_episode?: number;
  total_episode?: number;
  posters: string[];
  actors: string[];
  origin_name: string;
  isDeleted: boolean;
  source: string;
  createdAt: string;
  updatedAt: string;
}

export interface GetPaginationKKMoviesDto {
  page?: number;
  limit?: number;
  search?: string;
  status?: KKMovieStatusEnum;
  type?: KKMovieTypeEnum;
  sort?: string;
  source?: string;
}

export interface KKMovieListResponse {
  data: KKMovie[];
  pagination: {
    total: number;
    page: number;
    limit: number;
    totalPages: number;
  };
}

export interface CreateKKMovieDto {
  name: string;
  url: string;
  description?: string;
  year?: number;
  status?: KKMovieStatusEnum;
  type: KKMovieTypeEnum;
  current_episode?: number;
  total_episode?: number;
  posters?: string[];
  actors?: string[];
  origin_name?: string;
}

export interface UpdateKKMovieDto extends Partial<CreateKKMovieDto> {}

// KKPhim Episode Types

export enum EpisodeStatusEnum {
  PENDING = 'pending',
  SUCCESS = 'success',
  FAILED = 'failed',
}

export interface EpisodeServer {
  server_name: string;
  link_embed: string;
  link_m3u8: string;
}

export interface KKphimEpisode {
  _id: string;
  episode_id: string;
  name: string;
  slug: string;
  episode_number: number;
  filename: string;
  servers: EpisodeServer[];
  status: EpisodeStatusEnum;
  kkmovie_id: string | KKMovie;
  article_id?: string;
  createdAt: string;
  updatedAt: string;
}

export interface GetPaginationEpisodesDto {
  page?: number;
  limit?: number;
  kkmovie_id?: string;
  status?: EpisodeStatusEnum;
}

export interface EpisodeListResponse {
  data: KKphimEpisode[];
  pagination: {
    total: number;
    page: number;
    limit: number;
    totalPages: number;
  };
}

export interface CreateEpisodeDto {
  episode_id: string;
  name: string;
  slug?: string;
  episode_number: number;
  filename?: string;
  servers?: EpisodeServer[];
  status?: EpisodeStatusEnum;
  kkmovie_id: string;
  article_id?: string;
}

export interface BulkCreateEpisodeDto {
  episodes: CreateEpisodeDto[];
}

// Sync Types

export enum SyncStatusEnum {
  PENDING = 'pending',
  IN_PROGRESS = 'in_progress',
  SUCCESS = 'success',
  FAILED = 'failed',
  PARTIAL = 'partial',
}

export enum SyncTypeEnum {
  MANUAL = 'manual',
  SCHEDULED = 'scheduled',
  SINGLE = 'single',
  IMPORT_ALL = 'import_all',
  DAILY_NEW_IMPORT = 'daily_new_import',
}

export interface SyncLog {
  _id: string;
  type: SyncTypeEnum;
  status: SyncStatusEnum;
  source?: string;
  totalMovies: number;
  processedMovies: number;
  newEpisodesCount: number;
  newMoviesCount?: number;
  skippedCount?: number;
  totalPages?: number;
  currentPage?: number;
  failedCount: number;
  failedSlugs: string[];
  errorMessage: string;
  startedAt: string;
  completedAt?: string;
  triggeredBy?: string;
  createdAt: string;
  updatedAt: string;
}

export interface SyncStatus {
  isRunning: boolean;
  currentSync?: SyncLog;
  lastSync?: SyncLog;
  latestSync?: SyncLog;
  recentSyncs?: SyncLog[];
  stats?: {
    totalMoviesToSync: number;
    totalOngoing: number;
    totalUpcoming: number;
  };
}

export interface SyncHistoryResponse {
  data: SyncLog[];
  pagination: {
    total: number;
    page: number;
    limit: number;
    totalPages: number;
  };
}
